export const TermsOfService: React.FC = () => {
  return (
    <main className="bg-white-tos py-20-tos">
      <div className="container-tos">
        <div className="content-wrapper-tos">
          <h1 className="title-main-tos">Terms Of Service</h1>
          <h1 className="title-date-tos">Effective Date: 11/20/25</h1>

          {/* ----- Body sections start ----- */}
          <div className="section-tos">
            These Terms of Service (“Terms”) govern your access to and use of
            the services, software, websites, and applications (collectively,
            the “Services”) provided by Gallus Insights Ltd. (“Gallus Insights,”
            “we,” “us,” or “our”). By accessing or using the Services, you agree
            to be bound by these Terms. If you are entering into these Terms on
            behalf of a company or other legal entity, you represent that you
            have the authority to bind such entity. If you do not agree to these
            Terms, you must not use the Services.
          </div>

          {/* Overview of Services */}
          <div className="section-tos mb-2-tos">
            <div className="section-header-tos">Overview of Services</div>
            <div>
              Gallus Insights Ltd. provides business intelligence (BI) and data
              analytics tools designed for members of the mortgage industry. The
              Services include data ingestion, data storage, analytics, and
              visualization capabilities using:
              <ul className="list-tos">
                <li>
                  • Amazon Web Services (AWS) for hosting and infrastructure;
                </li>
                <li>• Snowflake for data warehousing and processing;</li>
                <li>• ThoughtSpot for data analytics and visualization.</li>
              </ul>
            </div>
          </div>

          {/* Eligibility */}
          <div className="section-tos mb-2-tos">
            <div className="section-header-tos">Eligibility</div>
            <div>
              You may use our Services only if you:
              <ul className="list-tos">
                <li>• Are at least 18 years old;</li>
                <li>
                  • Have the legal authority to enter into a binding agreement;
                </li>
                <li>
                  • Work within an organization in the mortgage industry or have
                  otherwise been granted access.
                </li>
              </ul>
            </div>
          </div>

          {/* Account Registration and Security */}
          <div className="section-tos mb-2-tos">
            <div className="section-header-tos">
              Account Registration and Security
            </div>
            <div>
              You are responsible for:
              <ul className="list-tos">
                <li>
                  • Providing accurate and complete registration information;
                </li>
                <li>
                  • Maintaining the confidentiality of your login credentials;
                </li>
                <li>
                  • Notifying us immediately if you suspect unauthorized use of
                  your account.
                </li>
                <li>• All activities that occur under your account.</li>
              </ul>
            </div>
          </div>

          {/* Use of the Services */}
          <div className="section-tos mb-2-tos">
            <div className="section-header-tos">Use of the Services</div>
            <div>
              You agree to use the Services solely for lawful business purposes
              related to your organization. You must not:
              <ul className="list-tos">
                <li>
                  • Attempt to access data or systems you are not authorized to
                  access;
                </li>
                <li>
                  • Reverse engineer, modify, or create derivative works of the
                  software powering the Services;
                </li>
                <li>
                  • Interfere with the operation or integrity of the Services;
                </li>
                <li>
                  • Use the Services to process unlawful, harmful, or misleading
                  information.
                </li>
              </ul>
              Gallus Insights reserves the right to suspend or terminate your
              access to the Services for violations of these Terms.
            </div>
          </div>

          {/* Data and Privacy */}
          <div className="section-tos mb-2-tos">
            <div className="section-header-tos">Data and Privacy</div>
            <div>
              “Customer Data” refers to any data you submit, store, or process
              through the Services. You retain ownership of all Customer Data.
              By using the Services, you grant Gallus Insights a limited license
              to process Customer Data solely for the purpose of providing,
              maintaining, and improving the Services. Customer Data may be
              stored or processed using third‑party providers, including AWS,
              Snowflake, and ThoughtSpot. You acknowledge and agree that:
              <ul className="list-tos">
                <li>• AWS provides hosting and security infrastructure;</li>
                <li>
                  • Snowflake stores and processes data in a cloud data
                  warehouse environment;
                </li>
                <li>
                  • ThoughtSpot powers data visualization and querying
                  functionalities.
                </li>
              </ul>
              Use of the Services is subject to the availability and performance
              of these third‑party systems.
            </div>
          </div>

          {/* Security */}
          <div className="section-tos mb-2-tos">
            <div className="section-header-tos">Security</div>
            <div>
              Gallus Insights implements industry‑standard administrative,
              physical, and technical safeguards to protect Customer Data.
              However, no system is completely secure, and we cannot guarantee
              absolute security.
            </div>
          </div>

          {/* Third‑Party Services */}
          <div className="section-tos mb-2-tos">
            <div className="section-header-tos">Third‑Party Services</div>
            <div>
              The Services may integrate with or rely upon third‑party
              platforms, including AWS, Snowflake, and ThoughtSpot. Gallus
              Insights is not responsible for the availability, performance, or
              security of these third‑party services. Your use of third‑party
              tools may be subject to their own terms and conditions.
            </div>
          </div>

          {/* Fees and Payment */}
          <div className="section-tos mb-2-tos">
            <div className="section-header-tos">Fees and Payment</div>
            <div>
              Access to the Services may require payment of subscription or
              usage‑based fees as described in your service order or agreement.
              Fees are:
              <ul className="list-tos">
                <li>• Due and payable as stated in your agreement;</li>
                <li>• Non‑refundable except as required by law;</li>
                <li>• Subject to change upon notice.</li>
              </ul>
              Failure to pay fees may result in suspension or termination of the
              Services.
            </div>
          </div>

          {/* Intellectual Property */}
          <div className="section-tos mb-2-tos">
            <div className="section-header-tos">Intellectual Property</div>
            <div>
              Gallus Insights retains all rights, title, and interest in:
              <ul className="list-tos">
                <li>
                  • The Services and all related software, designs, and
                  documentation;
                </li>
                <li>• All improvements, enhancements, and modifications.</li>
              </ul>
              These Terms do not grant you ownership of any intellectual
              property rights in the Services.
            </div>
          </div>

          {/* Confidentiality */}
          <div className="section-tos mb-2-tos">
            <div className="section-header-tos">Confidentiality</div>
            <div>
              Each party agrees to keep confidential all non‑public business,
              technical, or financial information obtained from the other party.
              Confidentiality obligations survive termination of these Terms.
            </div>
          </div>

          {/* Service Availability and Support */}
          <div className="section-tos mb-2-tos">
            <div className="section-header-tos">
              Service Availability and Support
            </div>
            <div>
              Gallus Insights strives to maintain reliable uptime but does not
              guarantee continuous availability of the Services. We may perform
              maintenance, upgrades, or emergency interventions that temporarily
              limit access. Support levels, response times, and service
              commitments may be outlined in a separate Service Level Agreement
              (SLA), if applicable.
            </div>
          </div>

          {/* Warranties and Disclaimers */}
          <div className="section-tos mb-2-tos">
            <div className="section-header-tos">Warranties and Disclaimers</div>
            <div>
              The Services are provided “as is” and “as available”, without
              warranties of any kind. Gallus Insights does not warrant that:
              <ul className="list-tos">
                <li>• The Services will be error‑free or uninterrupted;</li>
                <li>
                  • The Services will meet your specific business requirements;
                </li>
                <li>• Data will not be lost or corrupted.</li>
              </ul>
              To the maximum extent permitted by law, all implied warranties are
              excluded.
            </div>
          </div>

          {/* Limitation of Liability */}
          <div className="section-tos mb-2-tos">
            <div className="section-header-tos">Limitation of Liability</div>
            <div>
              To the fullest extent permitted by law, Gallus Insights is not
              liable for:
              <ul className="list-tos">
                <li>• Loss of profits, revenue, business, or data;</li>
                <li>• Indirect, incidental, or consequential damages;</li>
                <li>
                  • Our total liability for claims arising out of these Terms or
                  the Services will not exceed the amount you paid to Gallus
                  Insights in the preceding 12 months.
                </li>
              </ul>
            </div>
          </div>

          {/* Indemnification */}
          <div className="section-tos mb-2-tos">
            <div className="section-header-tos">Indemnification</div>
            <div>
              You agree to indemnify and hold harmless Gallus Insights from
              claims, damages, liabilities, and expenses arising from:
              <ul className="list-tos">
                <li>
                  • With or without cause, upon written notice as outlined in
                  your agreement;
                </li>
                <li>
                  • Immediately if the other party materially breaches these
                  Terms and fails to cure the breach.
                </li>
              </ul>
            </div>
          </div>

          {/* Termination */}
          <div className="section-tos mb-2-tos">
            <div className="section-header-tos">Termination</div>
            <div>
              Either party may terminate these Terms:
              <ul className="list-tos">
                <li>• Your use of the Services;</li>
                <li>• Your violation of these Terms;</li>
                <li>• Your infringement of third‑party rights.</li>
              </ul>
              Upon termination:
              <ul className="list-tos">
                <li>• Your access to the Services will cease;</li>
                <li>
                  • You may request data export within 30 days, unless otherwise
                  agreed.
                </li>
              </ul>
            </div>
          </div>

          {/* Modifications */}
          <div className="section-tos mb-2-tos">
            <div className="section-header-tos">Modifications</div>
            <div>
              We may update these Terms from time to time. Updated Terms become
              effective upon posting or as otherwise notified to you. Your
              continued use of the Services indicates acceptance of the updated
              Terms.
            </div>
          </div>

          {/* Governing Law */}
          <div className="section-tos mb-2-tos">
            <div className="section-header-tos">Governing Law</div>
            <div>
              These Terms are governed by the laws of the United States of
              America, without regard to conflict‑of‑law principles. Any
              disputes will be resolved exclusively in the courts of the United
              States of America.
            </div>
          </div>

          {/* Contact Information */}
          <div className="section-tos mb-2-tos">
            <div className="section-header-tos">Contact Information</div>
            <div>
              For questions about these Terms, please contact: Gallus Insights
              Ltd. Email: support@gallusinsights.com
            </div>
          </div>

          {/* Closing statement */}
          <div className="section-tos">
            By using the Services, you acknowledge that you have read,
            understood, and agree to be bound by these Terms.
          </div>
        </div>
      </div>
    </main>
  );
};
